<template>
  <div class="dining-section">
    <div class="dining-banner">
      <img
        src="@/assets/picture/Food/food.png"
        alt="Dining Image"
        class="banner-image"
      />
      <div class="banner-content">
        <h2>【在溫馨的氛圍中品味咖啡的美好】</h2>
        <p>
          每一杯咖啡都以匠心精神精心製作,帶給您醇香濃郁的味覺體驗。<br />
          在這裡,享受一杯暖心的咖啡,伴隨悠閒的時光與美好的對話。
        </p>
        <p>
          我們致力於選用頂級咖啡豆,結合創意甜點與健康輕食,為您打造專屬於咖啡廳的獨特氛圍。<br />
          不僅如此,還可在舒適的空間中感受陽光灑落,讓身心都得到放鬆,滿足您對生活美學的所有期待。
        </p>
      </div>
    </div>

    <!-- 電子書區域 -->
    <div class="ebook-container">
      <h3 class="ebook-title">墨韻咖啡菜單</h3>
      <div class="ebook-wrapper">
        <!-- 桌面版翻頁區域 -->
        <div class="desktop-book-wrapper" v-if="!isMobile">
          <button
            class="nav-button prev-button"
            @click="previousPage"
            :disabled="desktopCurrentPage <= 1"
          >
            <svg class="arrow-icon" viewBox="0 0 24 24" aria-hidden="true">
              <!--  控制：左箭頭 SVG  -->
              <path d="M15 18l-6-6 6-6" />
              <!--  控制：左箭頭線條路徑  -->
            </svg>
          </button>
          <div id="book" class="turn-page"></div>
          <button
            class="nav-button next-button"
            @click="nextPage"
            :disabled="isLastPage"
          >
            <svg class="arrow-icon" viewBox="0 0 24 24" aria-hidden="true">
              <!-- 控制：右箭頭 SVG -->
              <path d="M9 6l6 6-6 6" />
              <!-- 控制：右箭頭線條路徑 -->
            </svg>
          </button>
        </div>

        <!-- 手機版滑動瀏覽 -->
        <div class="mobile-menu" v-if="isMobile">
          <div class="menu-slider" ref="menuSlider">
            <div
              v-for="(page, index) in menuPages"
              :key="index"
              class="menu-page"
            >
              <img :src="page" :alt="`菜單第 ${index + 1} 頁`" />
            </div>
          </div>
          <div class="page-indicator">{{ currentPage }} / {{ totalPages }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import $ from "jquery";
import "turn.js";

export default {
  name: "FoodPage",
  data() {
    return {
      pdfUrl: "/pdf/menu.pdf",
      menuPages: [],
      isMobile: false,
      currentPage: 1,
      desktopCurrentPage: 1,
      totalPages: 0,
      startX: 0,
      currentX: 0,
      isDragging: false,
      resizeTimer: null,
    };
  },
  mounted() {
    pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
    this.checkMobile();
    window.addEventListener("resize", this.handleResize);
    this.loadPDF(this.pdfUrl);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    if (this.isMobile && this.$refs.menuSlider) {
      this.removeSwipeListeners();
    }
    if (!this.isMobile) {
      const book = document.getElementById("book");
      if (book && $(book).turn) {
        $(book).turn("destroy");
      }
    }
  },
  computed: {
    isLastPage() {
      if (this.totalPages === 0) return true;

      // turn.js 雙頁模式：最後一組通常是 totalPages 或 totalPages - 1
      return this.desktopCurrentPage >= this.totalPages - 1;
    },
  },

  methods: {
    checkMobile() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 768;
      return wasMobile !== this.isMobile;
    },
    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        const changed = this.checkMobile();

        if (changed) {
          this.loadPDF(this.pdfUrl);
        } else if (!this.isMobile) {
          const book = document.getElementById("book");
          if (book && $(book).turn) {
            const windowWidth = window.innerWidth;
            const bookWidth = windowWidth > 1200 ? 1000 : windowWidth * 0.9;
            const bookHeight = bookWidth * 0.75;
            $(book).turn("size", bookWidth, bookHeight);
          }
        }
      }, 250);
    },
    async loadPDF(pdfUrl) {
      try {
        const loadingTask = pdfjsLib.getDocument(pdfUrl);
        const pdfDoc = await loadingTask.promise;
        const pages = [];

        this.menuPages = [];

        for (let pageNum = 1; pageNum <= pdfDoc.numPages; pageNum++) {
          const page = await pdfDoc.getPage(pageNum);
          const scale = this.isMobile ? 2 : 1.5;
          const viewport = page.getViewport({ scale });

          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          await page.render({ canvasContext: context, viewport }).promise;

          const imgData = canvas.toDataURL();
          pages.push(imgData);
          this.menuPages.push(imgData);
        }

        this.totalPages = pages.length;

        if (!this.isMobile) {
          const bookElement = document.getElementById("book");
          if (!bookElement) return;

          if ($(bookElement).data("turn")) {
            $(bookElement).turn("destroy"); // 只有初始化過才 destroy
          }

          bookElement.innerHTML = pages
            .map((img) => `<div class="page"><img src="${img}" /></div>`)
            .join("");

          this.$nextTick(() => {
            setTimeout(() => {
              this.initTurnJS();
            }, 100);
          });
        } else {
          this.$nextTick(() => {
            this.initMobileSwipe();
          });
        }
      } catch (error) {
        console.error("PDF 載入錯誤:", error);
      }
    },
    initTurnJS() {
      const book = document.getElementById("book");
      if (!book) return;

      const windowWidth = window.innerWidth;
      const bookWidth = windowWidth > 1200 ? 1000 : windowWidth * 0.9;
      const bookHeight = bookWidth * 0.75;

      try {
        $(book).turn({
          width: bookWidth,
          height: bookHeight,
          autoCenter: true,
          gradients: true,
          acceleration: true,
          duration: 600,
          pages: this.totalPages,
        });

        $(book).bind("turning", (event, page) => {
          this.desktopCurrentPage = page;
        });

        console.log("Turn.js 初始化成功");
      } catch (error) {
        console.error("Turn.js 初始化失敗:", error);
      }
    },
    previousPage() {
      const book = document.getElementById("book");
      if (book && $(book).turn) {
        $(book).turn("previous");
      }
    },
    nextPage() {
      const book = document.getElementById("book");
      if (book && $(book).turn) {
        $(book).turn("next");
      }
    },
    initMobileSwipe() {
      const slider = this.$refs.menuSlider;
      if (!slider) return;

      slider.addEventListener("touchstart", this.handleTouchStart, {
        passive: true,
      });
      slider.addEventListener("touchmove", this.handleTouchMove, {
        passive: false,
      });
      slider.addEventListener("touchend", this.handleTouchEnd, {
        passive: true,
      });

      slider.addEventListener("mousedown", this.handleMouseDown);
      slider.addEventListener("mousemove", this.handleMouseMove);
      slider.addEventListener("mouseup", this.handleMouseEnd);
      slider.addEventListener("mouseleave", this.handleMouseEnd);
    },
    removeSwipeListeners() {
      const slider = this.$refs.menuSlider;
      if (!slider) return;

      slider.removeEventListener("touchstart", this.handleTouchStart);
      slider.removeEventListener("touchmove", this.handleTouchMove);
      slider.removeEventListener("touchend", this.handleTouchEnd);
      slider.removeEventListener("mousedown", this.handleMouseDown);
      slider.removeEventListener("mousemove", this.handleMouseMove);
      slider.removeEventListener("mouseup", this.handleMouseEnd);
      slider.removeEventListener("mouseleave", this.handleMouseEnd);
    },
    handleTouchStart(e) {
      this.startX = e.touches[0].clientX;
      this.isDragging = true;
    },
    handleTouchMove(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      this.currentX = e.touches[0].clientX;
    },
    handleTouchEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      const diff = this.startX - this.currentX;

      if (Math.abs(diff) > 50) {
        if (diff > 0 && this.currentPage < this.totalPages) {
          this.currentPage++;
        } else if (diff < 0 && this.currentPage > 1) {
          this.currentPage--;
        }
        this.scrollToPage();
      }
    },
    handleMouseDown(e) {
      this.startX = e.clientX;
      this.isDragging = true;
    },
    handleMouseMove(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      this.currentX = e.clientX;
    },
    handleMouseEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      const diff = this.startX - this.currentX;

      if (Math.abs(diff) > 50) {
        if (diff > 0 && this.currentPage < this.totalPages) {
          this.currentPage++;
        } else if (diff < 0 && this.currentPage > 1) {
          this.currentPage--;
        }
        this.scrollToPage();
      }
    },
    scrollToPage() {
      const slider = this.$refs.menuSlider;
      if (!slider) return;
      const pageWidth = slider.offsetWidth;
      slider.scrollTo({
        left: (this.currentPage - 1) * pageWidth,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style src="@/assets/css/food.css"></style>
